import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Services = require("../services/services");
import JSV = require("../utils/jsv");
import IPS = require("publicsector");
import Query = require("arcgis/services/featureserver/query");
import Base = require("./base/geoquery");
import FormTool = require("../controls/ips-geoquery-form-tool");

class Handler extends Base<{
    out: {
        controller: FormTool;
        command: Portal.CommandLeaf;
    }
}> {

    static about = `
Converts an auto-generated IPS query form data into an IPS REST query.
`;

    static options = Utils.defaults({
        "event": {
            "default": "geoquery-result",
        },
        "key-template": {
            "default": "<%=id%>",
        },
    }, Base.options);

    static output = {
        "layers": {
            "about": "the search results",
        },
    };

    // TODO: delegating most processing back to the form controller where the service configuration resides.
    // This is in contrast to the ogc and ags processor which handle everything locally
    execute(args = this.args) {

        let serviceInfo = this.asOptions(Handler.options);

        let data = this.asData();
        console.log("data: ", data);

        // http://usrcvqa4/GISPortalRS/api/cdr/applications/planning?
        // extendedFilter=[{operator:And,criteria:[{property:AddedDateTime,operator:GreaterThanOrEqual,value:2015-09-10T00:00:00.00Z}]}]&merge=true&format=json
        let query = this.asQuery(data);
        console.log("query: ", query);

        let services = this.getServices(serviceInfo);
        services = _.unique(services);

        services.forEach(queryService => {
            var service = new Services.BusinessService<IPS.GeoEntity>({
                query: {
                    extendedFilter: JSV.stringify(query),
                    merge: true
                }
            }, queryService);

            service.each().done(results => {
                let layer = this.processResults(results);
                this.assignKeys(layer);
                this.trigger({
                    layers: [layer]
                });
            });
        });

    }

    private get controller() {
        return this.args.out.controller;
    }

    private asData() {
        return this.controller.asData();
    }

    private asQuery(data: Array<{ name: string; value: any; }>) {
        return this.controller.asQuery(data);
    }

    private getServices(serviceInfo: Rhythm.GIS.Dictionary<string>) {
        return this.controller.getServices(serviceInfo);
    }

    private processResults(results: Array<IPS.GeoEntity>) {
        return this.controller.processResults(results);
    }

}

export = Handler;

